<button [disabled]="isDisabled" class="button is-small" (click)="_toggle()">
  <span class="checkbox-icon" [ngSwitch]="isDisplaySelected()">
    <i *ngSwitchCase="true" class="fa fa-check-square" aria-hidden="true"></i>
    <i *ngSwitchDefault class="far fa-square" aria-hidden="true"></i>
  </span>
</button>